export const getRootDomain = () => {
  const host = window.location.hostname; // e.g. a.example.com
  const parts = host.split(".");
  if (parts.length >= 2) {
    // 拼成主域名：example.com
    return parts.slice(-2).join(".");
  }
  return host; // localhost 或 IP
};

//  这是一个设置cookie的函数
export function setCookie(name, value, days, domain) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }

  let cookieStr =
    name + "=" + encodeURIComponent(value || "") + expires + "; path=/";

  if (domain) {
    cookieStr += "; domain=" + domain;
  }

  document.cookie = cookieStr;
}

/**
 * 获取指定名称的 cookie
 * @param name cookie 名称
 * @returns 返回 cookie 值，如果不存在返回 null
 */
export function getCookie(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  if (match) {
    return decodeURIComponent(match[2]); // 解码
  }
  return null;
}

// 从sso的回调url中获取utm参数
export const getUtmParams = () => {
  try {
    const fullUrl = window.location.href;
    const redirect = new URL(fullUrl).searchParams.get("redirect_uri");
    if (!redirect) return null;

    const d1 = decodeURIComponent(redirect);
    const target = new URL(d1).searchParams.get("target_url");
    const d2 = decodeURIComponent(target || "");

    //  d2的值是https://catalog.dev05.zetyun.cn/catalog/api/session/login?language=zh&redirect_url=https://catalog.dev05.zetyun.cn/activity/report/20260113?utm_source=alahomebaner&utm_campaign=tech_compute_selection_guide
    // 解析utm_campaign失败，可能是编码导致，换了种方式
    // const inner = new URL(d2).searchParams.get("redirect_url");
    // const d3 = decodeURIComponent(inner || "");

    // 由于 redirect_url 的值没有正确编码，& 被错误解析
    // 使用字符串截取方式提取 redirect_url= 后面的所有内容
    const redirectUrlKey = "redirect_url=";
    const idx = d2.indexOf(redirectUrlKey);
    let d3 = "";
    if (idx !== -1) {
      d3 = decodeURIComponent(d2.substring(idx + redirectUrlKey.length));
    }
    const redirectUrlParams = new URL(d3).searchParams;

    const utmParams = {};
    [
      "utm_source",
      "utm_campaign",
      "utm_medium",
      "utm_term",
      "utm_content",
    ].forEach((key) => {
      utmParams[key] = redirectUrlParams.get(key);
    });

    return utmParams;
  } catch (error) {
    return {};
  }
};

// 获取带有utm参数的url
export const getURLWithUtmParams = (url) => {
  const [pathname, search = ""] = url.split("?");
  const params = new URLSearchParams(search);

  // 强制注入全局参数
  Object.entries(getUtmParams()).forEach(([k, v]) => {
    if (v) {
      params.set(k, String(v));
    }
  });

  const queryString = params.toString();
  const newPath = queryString ? `${pathname}?${queryString}` : pathname;
  return newPath;
};


export const getCatalogEnvOrigin = () => {
  if (window.location.hostname.includes('zetyun-dev02.cn')) {
    return 'https://catalog.zetyun-dev02.cn';
  } else if (window.location.hostname.includes('ops01.zetyun.cn')) {
    return 'https://catalog.ops01.zetyun.cn';
  } else if (window.location.hostname.includes('unite.zetyun.cn')) {
    return 'https://catalog.unite.zetyun.cn';
  } else if (window.location.hostname.includes('bugfix.zetyun.cn')) {
    return 'https://catalog.bugfix.zetyun.cn';
  } else if (window.location.hostname.includes('demo.zetyun.cn')) {
    return 'https://catalog.demo.zetyun.cn';
  } else if (window.location.hostname.includes('dev05.zetyun.cn')) {
    return 'https://catalog.dev05.zetyun.cn';
  } else if (window.location.hostname.includes('zetyun-test.cn')) {
    return 'https://catalog.zetyun-test.cn';
  } else {
    return 'https://www.alayanew.com';
  }
};

export const getConsoleRedirectUri = () => `${getCatalogEnvOrigin()}/backend/console`;

export const buildAgreementPreviewUrl = (agreementId, objectId) =>
  `${getCatalogEnvOrigin()}/webapi/public/core/agreement/ops/agreements/${encodeURIComponent(
    agreementId,
  )}/objects/${encodeURIComponent(objectId)}/actions/preview`;